module.exports = __webpack_public_path__ + "img/cert.8a31c347.svg";